import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { ARTICLES, formatDateFr } from "../data/articles";

export default function Articles() {
  return (
    <div data-testid="articles-page" className="max-w-7xl mx-auto px-6 py-20">
      <div className="text-xs tracking-[0.3em] uppercase text-white/40">05 — Articles & ressources</div>
      <h1 className="font-heading text-5xl sm:text-6xl mt-3 tracking-tighter font-light max-w-4xl">
        Le blog du <span className="text-white/50">dessinateur BTP</span>.
      </h1>
      <p className="text-white/60 mt-6 max-w-2xl leading-relaxed">
        Conseils, méthodes et retours d'expérience pour les entreprises BTP, bureaux d'études,
        cabinets d'architecture et tous les acteurs du chantier.
      </p>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {ARTICLES.map((a) => (
          <Link
            key={a.slug}
            to={`/articles/${a.slug}`}
            data-testid={`article-card-${a.slug}`}
            className="group border border-[#1E2D4A] bg-[#0A1326] hover:border-white/50 transition-all duration-500 flex flex-col"
          >
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src={a.cover}
                alt={a.title}
                loading="lazy"
                className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A1326] to-transparent" />
            </div>
            <div className="p-6 flex-1 flex flex-col gap-3">
              <div className="flex items-center gap-3 text-xs text-white/40">
                <span>{formatDateFr(a.date)}</span>
                <span className="w-1 h-1 bg-white/30 rounded-full" />
                <span className="inline-flex items-center gap-1">
                  <Clock className="w-3 h-3" strokeWidth={1.5} />
                  {a.readTime} min
                </span>
              </div>
              <h2 className="font-heading text-xl leading-tight tracking-tight text-white group-hover:underline underline-offset-4">
                {a.title}
              </h2>
              <p className="text-sm text-white/60 leading-relaxed flex-1">{a.excerpt}</p>
              <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/70 pt-2 border-t border-[#1E2D4A] mt-2">
                Lire l'article
                <ArrowUpRight className="w-4 h-4 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" strokeWidth={1.5} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
